import Hero from "../components/home/Hero";
import DiwaliHampers from "../components/home/DiwaliHampers";
import FeaturedTiles from "../components/home/FeaturedTiles";
import BulkOrdersHub from "../components/home/BulkOrdersHub";
import WhyChoose from "../components/home/WhyChoose";
import { Helmet } from "react-helmet-async";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Helmet>
        <title>Naathi Charami Gifts & Hampers — Thoughtful Gifts for Every Occasion</title>
        <meta name="description" content="Premium hand-curated gift hampers from Hyderabad. Wedding, baby shower, corporate & festive hampers by Naathi Charami." />
        <meta property="og:title" content="Naathi Charami Gifts & Hampers" />
        <meta property="og:description" content="Thoughtful Gifts for Every Occasion — luxury hampers from Hyderabad." />
        <link rel="canonical" href="https://naathicharamigifts.com/" />
        {/* Organization / LocalBusiness JSON-LD */}
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "@id": "https://naathicharamigifts.com/#business",
          name: "Naathi Charami Gifts & Hampers",
          alternateName: "Naathi Charami",
          founder: { "@type": "Person", name: "Monalika Reddy" },
          description: "Premium, handcrafted gift hampers for weddings, baby showers, rakhi, birthdays, corporate gifting & every occasion. Founded by Monalika Reddy in Hyderabad.",
          url: "https://naathicharamigifts.com/",
          logo: "https://naathicharamigifts.com/favicon.svg",
          image: "https://naathicharamigifts.com/og-image.png",
          telephone: "+91-93460-42323",
          email: "naathicharami23@gmail.com",
          priceRange: "₹₹",
          address: {
            "@type": "PostalAddress",
            addressLocality: "Hyderabad",
            addressRegion: "Telangana",
            addressCountry: "IN",
          },
          areaServed: { "@type": "City", name: "Hyderabad" },
          sameAs: [
            "https://www.instagram.com/naathicharami_gifts/",
            "https://wa.me/919346042323",
          ],
          openingHoursSpecification: {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
            opens: "10:00",
            closes: "19:00",
          },
        })}</script>
        {/* WebSite + SearchAction so Google shows a Sitelinks search box */}
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "Naathi Charami Gifts & Hampers",
          url: "https://naathicharamigifts.com/",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://naathicharamigifts.com/shop/her?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        })}</script>
      </Helmet>
      <Hero />
      <DiwaliHampers />
      <FeaturedTiles />
      <BulkOrdersHub />
      <WhyChoose />
    </div>
  );
}
